import { SegmentBuilder } from "@/components/email/SegmentBuilder";
import { SavedGroups } from "@/components/email/SavedGroups";
import { SuppressionList } from "@/components/email/SuppressionList";

export const SegmentsTab = ({ segments, categories, suppressions, onSegmentsChanged, onSuppressionsChanged }) => (
  <div className="space-y-8">
    <SegmentBuilder categories={categories} onSegmentsChanged={onSegmentsChanged} />
    <SavedGroups segments={segments} onSegmentsChanged={onSegmentsChanged} />
    <SuppressionList suppressions={suppressions} onSuppressionsChanged={onSuppressionsChanged} />
  </div>
);
